import React from "react";
import projectsData from "../../data/projects.json"; // Adjust the path as necessary
import "./Projects.css"; // Custom styling

const handleImageSource = (imageSrc) => {
  let imagePath = "";

  if (imageSrc === "") {
    return imagePath;
  } else if (imageSrc.startsWith("http")) {
    return imageSrc;
  } else if (imageSrc.startsWith("assets/")) {
    try {
      imagePath = require(`../../${imageSrc}`);
    } catch (error) {
      console.error("Image not found:", error);
      imagePath = "";
    }
    return imagePath;
  } else {
    return imageSrc;
  }
};

function Projects() {
  return (
    <section className="projects-section container my-5">
      <h1 className="display-3 mb-5">Projects</h1>
      <div className="row">
        {projectsData.map((project, index) => (
          <div key={index} className="col-md-6 col-lg-4 mb-4 d-flex">
            <div className="card custom-card flex-fill">
              <figure className="card-image">
                <img
                  src={handleImageSource(project.image)}
                  className="card-img-top py-3"
                  alt={project.name}
                />
              </figure>
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">{project.name}</h5>
                <p>{project.appDescription}</p>
                <p>{project.techDescription}</p>
                <p>
                  <strong>Tech Stack: </strong>
                  {project.techStack}
                </p>
                <div className="mt-auto">
                  {project.liveSite && (
                    <a
                      href={project.liveSite}
                      className="btn btn-primary mb-2 w-100"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Live Site
                    </a>
                  )}
                  {project.sourceCode && (
                    <a
                      href={project.sourceCode}
                      className="btn btn-dark w-100"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Source Code
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Projects;
